<div class="display-frame">
    <div class="toolbar-container">
        <div class="toolbar">
            <div class="toolbar-menus">
                @if (isSignedIn && canViewHome) {
                    <div class="toolbar-menu-item">
                        <a routerLink="home">{{this.menu?.HomeTitle}}</a>
                    </div>
                }
                @for (menuItem of menuItems; track menuItem) {
                    @if (isAccountSelected && viewSecurity[menuItem.securityItem] && menuItem.menuLabel && menuItem.menuLabel !== '') {
                        <div class="toolbar-menu-item">
                            <a [routerLink]="menuItem.route">{{menuItem.menuLabel}}</a>
                        </div>
                    }
                }
                @if (isSignedIn && canViewUserMaintenance) {
                    <div class="toolbar-menu-item">
                        <a routerLink="users">{{this.menu?.UsersTitle}}</a>
                    </div>
                    <div class="toolbar-menu-item">
                        <a routerLink="account-maintenance">{{this.menu?.AccountsTitle}}</a>
                    </div>
                }
            </div>
            <div class="toolbar-login">
                @if (!isSignedIn) {
                    <a href="javascript:void(0)" (click)="onSignIn()" routerLink="login">Sign in</a>
                }
                @if (isSignedIn) {
                    <div class="toolbar-menu-item">
                        {{currentUser?.Name}}
                    </div>
                }
                @if (isSignedIn) {
                    <div class="toolbar-menu-item" style="cursor: pointer;">
                        <span (click)="onSignOut()">{{this.menu?.SignOutTitle}}</span>
                    </div>
                }
            </div>
            <div style="float: right; width: 175px; line-height: 21px; margin-right: 40px;">
                Language:&nbsp;
                <div style="width: 100px; float: right;">
                    <select [(ngModel)]="currentLanguageId" class="language-select" (change)="setLanguage($event.target)">
                        @for (language of languages; track language) {
                            <option [ngValue]="language.Id">{{language.Description}}</option>
                        }
                    </select>
                </div>
            </div>
        </div>
    </div>
</div>
